import(/* webpackMode: "eager" */ "/pupas/components/site-header.tsx")